[
  {
    "code": "GR-G-37",
    "name": "Achaia"
  },
  {
    "code": "GR-G-38",
    "name": "Aitoloakarnania"
  },
  {
    "code": "GR-L-59",
    "name": "Andros"
  },
  {
    "code": "GR-J-40",
    "name": "Arcadia"
  },
  {
    "code": "GR-J-41",
    "name": "Argolida"
  },
  {
    "code": "GR-D-19",
    "name": "Arta"
  },
  {
    "code": "GR-I-45",
    "name": "Central Athens"
  },
  {
    "code": "GR-F-35",
    "name": "Cephalonia"
  },
  {
    "code": "GR-B-13",
    "name": "Chalkidiki"
  },
  {
    "code": "GR-M-74",
    "name": "Chania"
  },
  {
    "code": "GR-K-57",
    "name": "Chios"
  },
  {
    "code": "GR-F-32",
    "name": "Corfu"
  },
  {
    "code": "GR-J-42",
    "name": "Corinth"
  },
  {
    "code": "GR-A-02",
    "name": "Drama"
  },
  {
    "code": "GR-I-49",
    "name": "East Attica"
  },
  {
    "code": "GR-A-03",
    "name": "Evros"
  },
  {
    "code": "GR-H-30",
    "name": "Evrytania"
  },
  {
    "code": "GR-H-29",
    "name": "Evvoia"
  },
  {
    "code": "GR-C-17",
    "name": "Florina"
  },
  {
    "code": "GR-H-31",
    "name": "Fokida"
  },
  {
    "code": "GR-H-27",
    "name": "Fthiotida"
  },
  {
    "code": "GR-C-15",
    "name": "Grevena"
  },
  {
    "code": "GR-M-71",
    "name": "Heraklion"
  },
  {
    "code": "GR-K-54",
    "name": "Ikaria"
  },
  {
    "code": "GR-G-39",
    "name": "Ileia"
  },
  {
    "code": "GR-B-08",
    "name": "Imathia"
  },
  {
    "code": "GR-D-18",
    "name": "Ioannina"
  },
  {
    "code": "GR-I-52",
    "name": "Islands"
  },
  {
    "code": "GR-F-34",
    "name": "Ithaca"
  },
  {
    "code": "GR-L-61",
    "name": "Kalymnos"
  },
  {
    "code": "GR-E-23",
    "name": "Karditsa"
  },
  {
    "code": "GR-L-62",
    "name": "Karpathos"
  },
  {
    "code": "GR-C-16",
    "name": "Kastoria"
  },
  {
    "code": "GR-A-05",
    "name": "Kavala"
  },
  {
    "code": "GR-L-63",
    "name": "Kea-Kythnos"
  },
  {
    "code": "GR-B-09",
    "name": "Kilkis"
  },
  {
    "code": "GR-L-64",
    "name": "Kos"
  },
  {
    "code": "GR-C-14",
    "name": "Kozani"
  },
  {
    "code": "GR-J-43",
    "name": "Lakonia"
  },
  {
    "code": "GR-E-22",
    "name": "Larisa"
  },
  {
    "code": "GR-M-72",
    "name": "Lasithi"
  },
  {
    "code": "GR-F-36",
    "name": "Lefkada"
  },
  {
    "code": "GR-K-55",
    "name": "Lemnos"
  },
  {
    "code": "GR-K-53",
    "name": "Lesvos"
  },
  {
    "code": "GR-E-24",
    "name": "Magnisia"
  },
  {
    "code": "GR-J-44",
    "name": "Messinia"
  },
  {
    "code": "GR-L-65",
    "name": "Milos"
  },
  {
    "code": "GR-69-99",
    "name": "Mount Athos Autonomous Region"
  },
  {
    "code": "GR-L-66",
    "name": "Mykonos"
  },
  {
    "code": "GR-L-67",
    "name": "Naxos"
  },
  {
    "code": "GR-I-46",
    "name": "North Athens"
  },
  {
    "code": "GR-E-25",
    "name": "Northern Sporades"
  },
  {
    "code": "GR-L-68",
    "name": "Paros"
  },
  {
    "code": "GR-B-10",
    "name": "Pella"
  },
  {
    "code": "GR-B-11",
    "name": "Pieria"
  },
  {
    "code": "GR-I-51",
    "name": "Piraeus"
  },
  {
    "code": "GR-D-21",
    "name": "Preveza"
  },
  {
    "code": "GR-M-73",
    "name": "Rethymno"
  },
  {
    "code": "GR-L-69",
    "name": "Rhodes"
  },
  {
    "code": "GR-A-01",
    "name": "Rodopi"
  },
  {
    "code": "GR-K-56",
    "name": "Samos"
  },
  {
    "code": "GR-L-60",
    "name": "Santorini"
  },
  {
    "code": "GR-B-12",
    "name": "Serres"
  },
  {
    "code": "GR-I-48",
    "name": "South Athens"
  },
  {
    "code": "GR-L-58",
    "name": "Syros"
  },
  {
    "code": "GR-A-04",
    "name": "Thasos"
  },
  {
    "code": "GR-D-20",
    "name": "Thesprotia"
  },
  {
    "code": "GR-B-07",
    "name": "Thessaloniki"
  },
  {
    "code": "GR-L-70",
    "name": "Tinos"
  },
  {
    "code": "GR-E-26",
    "name": "Trikala"
  },
  {
    "code": "GR-H-28",
    "name": "Viotia"
  },
  {
    "code": "GR-I-47",
    "name": "West Athens"
  },
  {
    "code": "GR-I-50",
    "name": "West Attica"
  },
  {
    "code": "GR-A-06",
    "name": "Xanthi"
  },
  {
    "code": "GR-F-33",
    "name": "Zakynthos"
  }
]